import axios from "@/lib/axios";
import { DimensionId, QuestionnaireResultStatus } from "@/types/questionnaries";

export type PerformanceDetailReportRequestParams = {
  companyId: string;
  applicationQuizId: string;
};

export type DimensionResult = {
  dimension: {
    dimension: string;
    group: string;
    order: number;
    name: string;
  };
  result: {
    score: number;
    scorePercentage: number;
    scoreProportion: number;
  };
  topicsResult: Array<{
    topic: {
      topic: string;
      name: string;
    };
    result: {
      score: number;
      scorePercentage: number;
      scoreProportion: number;
    };
  }>;
};

export type HighlightedTopic = {
  topic: {
    topic: string;
    name: string;
    dimension: {
      dimension: DimensionId;
      group: string;
      order: number;
      name: string;
    };
  };
  result: {
    score: number;
    scorePercentage: number;
    scoreProportion: number;
  };
};

export type PerformanceDetailReportResponse = {
  score: number;
  resultStatus: QuestionnaireResultStatus;
  color: string;
  summary: {
    totalApplicants: number;
    totalSectorsParticipants: number;
    totalDimensionsEvaluated: number;
    totalTopicsEvaluated: number;
    totalQuestionsEvaluated: number;
  };
  dimensionsResult: Array<DimensionResult>;
  highlightedTopics: Array<HighlightedTopic>;
};

export const getPerformanceDetailReport = (
  params: PerformanceDetailReportRequestParams,
) =>
  axios
    .get<PerformanceDetailReportResponse>(
      `/v1/companies/${params.companyId}/reports/questionnaires/performance-detail/${params.applicationQuizId}`,
    )
    .then((r) => r.data);
